import React from 'react';
import Modal from '../../Atoms/Modal/Modal';
import brain from '../../../assets/Imagess/outcomeIcons/brain.svg';
import checklist from '../../../assets/Imagess/outcomeIcons/checklist.svg';
import clock from '../../../assets/Imagess/outcomeIcons/clock.svg';
import earth from '../../../assets/Imagess/outcomeIcons/earth.svg';
import graduation from '../../../assets/Imagess/outcomeIcons/graduation.svg';
import grouphands from '../../../assets/Imagess/outcomeIcons/grouphands.svg';
import lawbook from '../../../assets/Imagess/outcomeIcons/lawbook.svg';
import lawchecklist from '../../../assets/Imagess/outcomeIcons/lawchecklist.svg';
import search from '../../../assets/Imagess/outcomeIcons/search.svg';
import stamp from '../../../assets/Imagess/outcomeIcons/stamp.svg';
import thumbsup from '../../../assets/Imagess/outcomeIcons/thumbsup.svg';
const iconLookup = {
  brain: { src: brain, alt: 'Brain' },
  checklist: { src: checklist, alt: 'Checklist' },
  clock: { src: clock, alt: 'Clock' },
  earth: { src: earth, alt: 'Earth' },
  graduation: { src: graduation, alt: 'Graduation' },
  grouphands: { src: grouphands, alt: 'Group Hands' },
  lawbook: { src: lawbook, alt: 'Law Book' },
  lawchecklist: { src: lawchecklist, alt: 'Law Checklist' },
  search: { src: search, alt: 'Search' },
  stamp: { src: stamp, alt: 'Stamp' },
  thumbsup: { src: thumbsup, alt: 'Thumbs Up' },
};

export const getIconByName = (name) => {
  if (name) {
    const formattedName = name?.replace(/\.svg$/, '');
    return iconLookup[formattedName] || null;
  }
};
const AddIconModal = ({ handleOnClose, onIconSelect }) => {
  const icons = [
    { src: brain, name: 'brain', alt: 'Brain' },
    { src: checklist, name: 'checklist', alt: 'Checklist' },
    { src: clock, name: 'clock', alt: 'Clock' },
    { src: earth, name: 'earth', alt: 'Earth' },
    { src: graduation, name: 'graduation', alt: 'Graduation' },
    { src: grouphands, name: 'grouphands', alt: 'Group Hands' },
    { src: lawbook, name: 'lawbook', alt: 'Law Book' },
    { src: lawchecklist, name: 'lawchecklist', alt: 'Law Checklist' },
    { src: search, name: 'search', alt: 'Search' },
    { src: stamp, name: 'stamp', alt: 'Stamp' },
    { src: thumbsup, name: 'thumbsup', alt: 'Thumbs Up' },
  ];

  return (
    <Modal onClose={handleOnClose} title='تعيين الأيقونة' closeWhite={false}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '32px',
          maxWidth: '600px',
          direction: 'rtl',
        }}
      >
        {icons.map((icon, index) => (
          <img
            key={index}
            src={icon.src}
            alt={icon.alt}
            style={{ width: '50px', height: '50px', cursor: 'pointer' }}
            onClick={() => onIconSelect(icon.name)}
          />
        ))}
      </div>
    </Modal>
  );
};

export default AddIconModal;
